import { Component, OnInit, Optional } from '@angular/core';
import { MobileWebViewService } from '@mpt-fo/common/core/services/mobile-web-view.service';
import { Router } from '@angular/router';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { DeviceService } from '@mpt-fo/common/core/services/device.service';

@Component({
	selector: 'app-device-registration-modal',
	templateUrl: './device-registration-modal.component.html',
	styleUrls: ['./device-registration-modal.component.scss'],
})
export class DeviceRegistrationModalComponent implements OnInit {
	constructor(
		private mobileService: MobileWebViewService,
		private deviceService: DeviceService,
		private router: Router,
		@Optional() private modal: NzModalRef
	) {}

	ngOnInit(): void {}

	dismissModal() {
		this.modal.destroy();
		this.router.navigateByUrl('/login');
	}

	registerDevice() {
		this.modal.destroy();
		this.router.navigateByUrl('/mobile/device-registration');
	}
}
